export default {
  "foot": {
    "title": "Pemain Century Games",
    "p1": "Masukkan ID Pengguna kamu, lakukan pembayaran untuk top-up. Jumlah akan diperbarui langsung di akun milikmu yang terkait. Jika tidak tampil, mohon memuat ulang permainan atau hubungi layanan konsumen jika diperlukan.",
    "p2": "JIka kamu memiliki pertanyaan, silakan hubungi layanan pelanggan. Terima kasih atas dukunganmu!",
    "copyright": "© Copyright 2024 Century Games.",
    "service": "Perjanjian  Layanan",
    "policy": "Kebijakan Privasi",
    "descriptionTitle": "Bagaimana Cara Kerjanya?"
  },
  "accept": {
    "title": "Website ini menggunakan cookie untuk menjadikan pengalaman browsing kamu lebih baik. Silakan baca <a href=\"https://www.centurygames.com/privacy-policy/\" style=\"color: #58a8a5;\">Kebijakan Privasi</a> kami untuk informasi tentang apa yang kami kumpulkan di website kami. Dengan melanjutkan menggunakan website ini, kamu setuju bahwa kami dapat menyimpan dan mengakses cookie di perangkatmu.",
    "decline": "Tolak",
    "accept": "Terima"
  },
  "game": {
    "inapptext": "Atau Login melalui Game",
    "loginfail": "Login Gagal",
    "logintip": "Jika game gagal diotorisasi, silakan update game ke versi terbaru atau coba browser lain.",
    "reloadmsg": "Silakan ketuk tombol 'Muat Ulang' untuk mendapatkan hasil login.",
    "reload": "Muat Ulang",
    "appnotice": "Jika kamu ingin log in melalui aplikasi game, silakan gunakan browser eksternal untuk membuka toko.",
    "changeaccount": "Yakin ingin log out dari akunmu?",
    "login": "Log In",
    "notice": "Pengingat",
    "confirm": "OK",
    "loginuserid": "ID Pengguna",
    "palceholder": "Masukkan ID Pengguna",
    "okbtn": "OK",
    "loginbtn": "Login melalui Game",
    "changebtn": "Atau Login dengan ID Pengguna",
    "useTitle": "AKUN",
    "checkBtn": "Periksa",
    "findid": "Tidak menemukan ID Pengguna kamu?",
    "checktext": "Biasanya ditemukan di pengaturan, ketuk tanda tanya untuk detail panduan",
    "username": "Nickname:",
    "userId": "ID Pengguna:",
    "packageTitle": "JUMLAH TOP-UP",
    "edit": "Edit",
    "paymentTitle": "METODE PEMBAYARAN",
    "total": "Total",
    "goPay": "Bayar Sekarang",
    "noSelectPackageTips": "Kamu tidak memilih jumlah apa pun",
    "payFail": "PEMBAYARAN GAGAL",
    "camelPayfail": "Pembayaran Gagal",
    "payFailTips1": "Silakan hubungi Layanan Pelanggan Adyen",
    "payFailTips2": "Silakan hubungi Layanan Pelanggan PayPal",
    "paySuccess": "PEMBAYARAN BERHASIL",
    "paySuccessTips2": "Muat ulang game terlebih dahulu sebelum menghubungi Layanan Pelanggan jika tidak menerima pembelianmu!",
    "camelPaySuccess": "Pembayaran Berhasil",
    "transactionId": "ID Transaksi",
    "paySuccessTips": "Pengiriman item akan memakan waktu, harap tunggu",
    "deliveryFail": "PENGIRIMAN GAGAL",
    "deliveryFailTips": "Silakan hubungi Layanan Pelanggan",
    "orderTitle": "Ringkasan Pesananmu",
    "paidWith": "Metode Pembayaran",
    "orderID": "ID Transaksi",
    "payStatus": "Status Pembayaran",
    "orderTotal": "Total Harga",
    "transactionDate": "Tanggal Transaksi",
    "goOnPay": "Beli Lagi",
    "getInvoice": "Invoice",
    "camelDeliveryFail": "Pengiriman Gagal",
    "confirmOrder": "KONFIRMASI PESANAN",
    "confirmFollow": "Silakan konfirmasi info berikut:",
    "nickname": "Nickname",
    "packageName": "Item",
    "totalPayment": "Total Harga",
    "confirmPayWith": "Metode Pembayaran",
    "confirmAndGoOn": "Konfirmasi & Lanjutkan ke Pembayaran",
    "orderCancel": "Batalkan",
    "getInvoiceTitle": "KIRIMKAN MELALUI EMAIL",
    "getInvoiceTips": "Jika kamu ingin menerima invoice melalui email, silakan masukkan alamat email",
    "getInvoiceTips1": "Masukkan email-mu untuk menerima invoice",
    "getInvoiceTips2": "Setuju dengan pengumpulan dan penyimpanan alamat email kamu oleh kami",
    "getInvoiceTips3": "Setuju untuk menerima email tentang diskon, promosi, dan lainnya untuk game kami melalui email",
    "invoiceSend": "Kirim",
    "sendSuccess": "Email Invoice Terkirim",
    "id404": "ID Pengguna tidak ditemukan",
    "packageLoadingText": "Item toko diperbarui ....",
    "taxTips": "Harga termasuk pajak",
    "adyenTips": "Layanan pembayaran disediakan oleh Adyen, yang beroperasi di bawah lisensi perbankan dan diawasi oleh Dutch Central Bank. Jika kamu memiliki pertanyaan tentang Sertifikasinya, silakan merujuk ke <a href=\"https://www.adyen.com/platform/certifications\">https://www.adyen.com/platform/certifications</a>. Mengenai cara mereka melindungi datamu, silakan merujuk ke <a href=\"https://www.adyen.com/policies-and-disclaimer/privacy-policy\">https://www.adyen.com/policies-and-disclaimer/privacy-policy</a>.",
    "paypalTips": "Layanan pembayaran disediakan oleh PayPal. Mengenai cara mereka melindungi datamu, silakan merujuk ke <a href=\"https://www.paypal.com/c2/webapps/mpp/ua/privacy-full\">https://www.paypal.com/c2/webapps/mpp/ua/privacy-full</a>",
    "switchCountryTips": "Negara/wilayah pilihanmu adalah ${servercountry}. Yakin ingin mengganti negara dan mata uang?",
    "paypalBtn": "Bayar dengan Kartu Sekarang",
    "paypalOr": "Atau",
    "paypalCard1": "Nama Pemilik Kartu (opsional)",
    "paypalCard2": "Nomor Kartu",
    "checkUserID": "Tautkan",
    "success": "SUKSES",
    "changeCurrencyContent": "Apakah kamu ingin mengganti wilayah dan mata uang agar sesuai dengan pengaturan dalam game kamu: ${servercountry}?",
    "productDescription": "Farm Bucks adalah uang tunai yang dapat digunakan untuk membeli semua paket dan penawaran dalam permainan.",
    "payButton": "BAYAR",
    "userIdNotice": "Silakan masukkan ID Pengguna kamu untuk menautkannya ke akun game-mu terlebih dahulu",
    "account": "Akun",
    "card": "Kartu",
    "notification": "Masukkan ID Penggunamu untuk menautkan akunmu, pilih item yang diinginkan, lalu bayar dengan metode pembayaran pilihanmu. Setelah memuat ulang game, item yang dibeli akan muncul di akunmu dan siap digunakan.\n\nJika kamu memiliki pertanyaan, silakan hubungi layanan pelanggan di dalam game.",
    "rongluRank": "Level Tungku:",
    "tips": "Bagaimana cara menggunakannya?",
    "checkTIps1": "Saya telah membaca dan menyetujui <a :href=\"policyUrl\">\"Kebijakan Privasi\"</a>, <a :href=\"serviceURl\">\"Ketentuan Layanan\"</a> dan <a :href=\"paymentURl\">\"Ketentuan Pembayaran\"</a>.",
    "checkTIps2": "Harap baca dan centang kotak centang.",
    "selectTips": "(Mata uang dari pembelian terbaru dalam game akan dipilih)",
    "koPayTips": "Jika kartu bank Anda menggunakan Won Korea sebagai mata uang asing, layanan Dynamic Currency Conversion (DCC) akan digunakan, dan biaya penanganan tambahan mungkin dikenakan oleh pihak ketiga dan bukan oleh situs web ini.",
    "PayTips": ""
  },
  "invoice": {
    "title": "Invoice",
    "transactionId": "ID Transaksi",
    "transactionDate": "Tanggal Transaksi",
    "totalAmount": "Total Jumlah",
    "paymentMethod": "Metode Pembayaran",
    "description": "Deskripsi",
    "game": "Game",
    "quantity": "Jumlah",
    "price": "Harga",
    "amount": "Total Harga",
    "total": "Total Harga",
    "footTitle": "Catatan",
    "footContent": "Terima kasih atas dukunganmu terhadap Century Games!",
    "button1": "Dapatkan Invoice",
    "button2": "Kembali Tanpa Invoice",
    "giveupInvoice": "Kamu tidak akan mendapatkan tanda terima untuk pesanan ini. Konfirmasi?"
  },
  "payment": {
    "card": "Kartu Kredit/Kartu Debit",
    "paypal": "PayPal"
  },
  "country": {
    "countryTitle1": "NEGARA/WILAYAH",
    "Africa": "Afrika",
    "America": "Amerika",
    "Asia": "Asia",
    "Europe": "Eropa",
    "Oceania": "Oceania",
    "ZA": "Afrika Selatan",
    "US": "Amerika Serikat",
    "HK": "Hong Kong, China",
    "JP": "Jepang",
    "KR": "Korea",
    "SG": "Singapura",
    "SA": "Arab Saudi",
    "IQ": "Irak",
    "TW": "Taiwan, China",
    "TH": "Thailand",
    "GB": "Britania Raya",
    "AU": "Australia",
    "countryLanguage1": "BAHASA",
    "AE": "Uni Emirat Arab",
    "DE": "Jerman",
    "PT": "Portugal",
    "RU": "Rusia",
    "ES": "Spanyol",
    "CH": "Swiss",
    "TR": "Turki",
    "KW": "Kuwait",
    "QA": "Qatar",
    "PL": "Polandia",
    "ID": "Indonesia",
    "IT": "Italia",
    "IN": "India",
    "FR": "Prancis",
    "CA": "Kanada",
    "NL": "Belanda",
    "AT": "Austria",
    "RS": "Serbia",
    "SE": "Swedia",
    "MY": "Malaysia",
    "BE": "Belgia",
    "DK": "Denmark",
    "FI": "Finlandia",
    "PH": "Filipina",
    "NO": "Norwegia",
    "BR": "Brasil",
    "NZ": "Selandia Baru",
    "UA": "Ukraina",
    "RO": "Rumania"
  },
  "extra_info": {
    "kingdom": "Wilayah: #"
  },
  "adyen": {
    "note": "Layanan pembayaran ini disediakan oleh Adyen, yang menawarkan transaksi aman dengan sertifikasi PCI-DSS level tertinggi dari organisasi kartu kredit internasional yang mendukung pembayaran kartu baik di dalam mau pun di luar negeri.",
    "note2": "Catatan: Centang \"Simpan untuk pembayaran berikutnya\" untuk menyimpan informasi kartu pembayaranmu pada browser saat ini untuk pembayaran ke depannya."
  },
  "pay": {
    "error1": "Jika terjadi kesalahan, silakan coba lagi nanti atau gunakan metode pembayaran lain. Silakan hubungi dukungan pelanggan jika Anda memiliki pertanyaan lebih lanjut."
  },
  "meta": {
    "title": "Toko Family Farm Adventure",
    "description": "Toko Family Farm Adventure adalah toko resmi dari Family Farm Adventure, menyediakan saluran top-up di diskon dan paket dalam game untuk pemain.",
    "keywords": "pertanian, kultivasi, pasar, peningkatan, eksplorasi, peta, karakter, level, simulasi, strategi, bayar, toko, isi ulang, pembayaran"
  }
};


// WEBPACK FOOTER //
// ./src/lang/ID.js